import { useEffect, useState } from 'react';
import { Select, SelectProps } from '@ets/design-system';

type LanguageSelectProps = Pick<
  SelectProps<Services.Language>,
  'value' | 'onChange' | 'size' | 'testId'
> & {
  options: Services.Language[];
};

const LanguageSelect = ({ value, options, onChange, size = 'l', testId }: LanguageSelectProps) => {
  const [languageOptions, setLanguageOptions] = useState<Services.Language[]>(options);

  useEffect(() => {
    setLanguageOptions(
      options?.map((option) => {
        if (option.supported) {
          return { ...option, suffix: { icon: { icon: 'font' } } };
        } else {
          return option;
        }
      }),
    );
  }, [options]);

  return (
    <Select
      variant="standard"
      isCreatable
      menuPlacement="bottom"
      menuPosition="fixed"
      options={languageOptions}
      value={value}
      onChange={onChange}
      size={size}
      width="100%"
      testId={testId}
      isClearable
    />
  );
};

export default LanguageSelect;
